import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const RedirectsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "RedirectsComponent" */ "@circle-react/components/SettingsApp/Site/Redirects"
    ),
);

export const Redirects = () => (
  <Suspense fallback={<PageLoader />}>
    <RedirectsComponent />
  </Suspense>
);
